import { FormattedText, ToolTipComp } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { MyCashProps } from "../../pages/InsuranceLanding/types";
import {
  GradientText,
  IconContainer,
  InfoIcon,
  MyCashBanner,
  ShieldIcon,
  TextContainer,
} from "./MyCash.style";

const MyCash: React.FC<MyCashProps> = ({ iconUrl, text, tooltip }) => {
  const portalRef = useRef<HTMLElement | null>(null);
  const iconRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    portalRef.current = document.querySelector<HTMLElement>("#portal");
  }, []);

  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const device = useBreakpointV2();

  const handleMouseEnter = () => {
    if (iconRef?.current) {
      const rect = iconRef?.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.bottom + window.scrollY - 35, // Position below icon
        left: rect.left + window.scrollX + rect.width + 15, // Center tooltip
      });
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <MyCashBanner>
      <IconContainer>
        <ShieldIcon iconUrl={iconUrl} />
      </IconContainer>

      <TextContainer>
        <GradientText>{text?.value}</GradientText>

        {tooltip?.icon && (
          <>
            <InfoIcon
              ref={iconRef}
              src={tooltip?.icon}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
            {isHovered &&
              portalRef?.current &&
              createPortal(
                <div
                  style={{
                    position: "absolute",
                    top: `${tooltipPos?.top}px`,
                    left: `${tooltipPos?.left}px`,
                    transform: "translateX(-50%)", // Centering tooltip
                    zIndex: 1000,
                  }}
                >
                  <ToolTipComp
                    handleMouseEnter={handleMouseEnter}
                    handleMouseLeave={handleMouseLeave}
                    // top={`${tooltipPos.top}px`}
                    // left={`${tooltipPos.left}px`}
                    toolTipArrow={device === "lg" ? "left" : "bottom"}
                    width="218px"
                    backgroundColor="black"
                    zIndex={10}
                  >
                    <FormattedText value={tooltip?.description} />
                  </ToolTipComp>
                </div>,
                portalRef?.current
              )}
          </>
        )}
      </TextContainer>
    </MyCashBanner>
  );
};

export default MyCash;
